// extracted by mini-css-extract-plugin
module.exports = {"tasteCard2Text":"components-TasteCard2-TasteCard2Text-TasteCard2Text__tasteCard2Text--1Bgef","attraction":"components-TasteCard2-TasteCard2Text-TasteCard2Text__attraction--3Tikv"};